require('./profileSettingsSummary.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { Toggle } = require('commonsComponents/toggle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');


class ProfileSettingsSummary extends React.Component {
    constructor(props) {
        super(props);

        this.handleUpArrowClick = this.handleUpArrowClick.bind(this);
        this.handleDownArrowClick = this.handleDownArrowClick.bind(this);
    }

    handleUpArrowClick() {
        this.props.onUpArrowClicked(this.props.index);
    }

    handleDownArrowClick() {
        this.props.onBottomArrowClicked(this.props.index);
    }

    render() {
        const {
            checked,
            handleClick,
            index,
            numberOfAccounts,
            subTitle,
            smallTitle,
            title
        } = this.props;

        const wrapWithTooltip = (target) => (
            <OKTooltip
                content="profileSettingsSummary-tooltipContent"
                offset={[0, -10]}
                target={target}
            />
        );
        const topIcon = <i className="icon-accordion-cerrar profile-settings-summary__top-icon" />;
        const bottomIcon = <i className="icon-accordion-abrir profile-settings-summary__bottom-icon" />;
        const wrappedIconWithTooltipTop = wrapWithTooltip(topIcon);
        const wrappedIconWithTooltipBottom = wrapWithTooltip(bottomIcon);
        const upArrowDisabled = index === 0 || !checked;
        const downArrowDisabled = index === numberOfAccounts - 1 || !checked;
        let upArrowButton;
        let downArrowButton;
        if (numberOfAccounts > 1) {
            upArrowButton = (
                <OKButton
                    onClick={this.handleUpArrowClick}
                    disabled={upArrowDisabled}
                >
                    {wrappedIconWithTooltipTop}
                </OKButton>
            )
            downArrowButton = (
                <OKButton
                    onClick={this.handleDownArrowClick}
                    disabled={downArrowDisabled}
                >
                    {wrappedIconWithTooltipBottom}
                </OKButton>
            )
        }
        return (
            <div className="profile-settings-summary">
                <div className="profile-settings-summary__text">
                    <div className="profile-settings-summary__toggle">
                        <Toggle checked={checked} onClick={handleClick} />
                    </div>
                    <div className="profile-settings-summary__icon">
                        {upArrowButton}
                        {downArrowButton}
                    </div>
                    <p className="profile-settings-summary__title">{title}
                        <span className="profile-settings-summary__title--small">{smallTitle}</span>
                    </p>
                    <p className="profile-settings-summary__subtitle"> {subTitle}</p>
                </div>
            </div>
        );
    }
}

ProfileSettingsSummary.propTypes = {
    checked: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    index: PropTypes.number,
    numberOfAccounts: PropTypes.number,
    onUpArrowClicked: PropTypes.func,
    onBottomArrowClicked: PropTypes.func,
    subTitle: PropTypes.string,
    smallTitle: PropTypes.string,
    title: PropTypes.string.isRequired
};

module.exports = ProfileSettingsSummary;
